import { render, staticRenderFns } from "./DemoSignUpModal.vue?vue&type=template&id=19da763c"
import script from "./DemoSignUpModal.vue?vue&type=script&lang=js"
export * from "./DemoSignUpModal.vue?vue&type=script&lang=js"
import style0 from "./DemoSignUpModal.vue?vue&type=style&index=0&id=19da763c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports